var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ng-sheet',_vm._g(_vm._b({staticClass:"social-icon",attrs:{"color":_vm.colors[_vm.name],"title":_vm.name,"xs":""}},'ng-sheet',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(" "+_vm._s(`mdi-${_vm.name}`))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }